export { default } from './SoapLeft';

export { default as DiagnosisTabPanel } from './DiagnosisTabPanel';
export { default as DocumentsTabPanel } from './DocumentsTabPanel';
export { default as MedicalHxTabPanel } from './MedicalHxTabPanel';
export { default as SoapTabPanel } from './SoapTabPanel';
export { default as SoapTabs } from './SoapTabs';